const getOrderStatusByToken = async function ({ commit }, { orderId, token }) {
    try {
        const { data } = await this.$axios.get(
            this.$config.platform.apis.orders + orderId + `?token=${token}`
        )

        // We need to make sure that the payment key exists with an empty obj
        // if the api sends us back a null value for it.
        if (!data.payment) data.payment = {}

        commit('setOrderStatus', data)
    } catch (err) {
        throw err.response.data
    }
}

const orderLogin = function (context, params) {
    return this.$axios.get(this.$config.platform.apis.orderLookup, { params })
}

const getOrderTrackingDetails = async function ({ commit }, params) {
    try {
        const { data } = await this.$axios.get(
            this.$config.platform.apis.tracking + params.trackingId
        )
        commit('setOrderTrackingDetails', data)
    } catch (err) {
        throw err.response.data
    }
}

const cancelOrder = async function ({ commit, dispatch }, { orderId, cancellationDetails }) {
    try {
        const resp = await this.$axios.put(this.$config.platform.apis.orders + orderId, {
            shippingStatus: 'CANCELLED',
            cancellationDetails,
        })
        commit('setOrderStatus', resp.data.data)
        dispatch('addGeneralSuccess', { message: resp.data.msg }, { root: true })
    } catch (err) {
        if (err && err.response) dispatch('addGeneralError', err.response.data.msg, { root: true })
        else dispatch('addGeneralError', err, { root: true })
    }
}

const cancelOrderline = async function ({ dispatch }, { orderId, itemId, cancellationDetails }) {
    try {
        const resp = await this.$axios.put(
            `${this.$config.platform.apis.orders}${orderId}/items/${itemId}`,
            {
                shippingStatus: 'CANCELLED',
                cancellationDetails,
            }
        )
        dispatch('addGeneralSuccess', { message: resp.data.msg }, { root: true })
        return
    } catch (err) {
        if (err && err.response) dispatch('addGeneralError', err.response.data.msg, { root: true })
        else dispatch('addGeneralError', err, { root: true })
    }
}

const returnItem = async function ({ dispatch }, { orderId, itemId, returnDetails }) {
    try {
        const resp = await this.$axios.put(
            `${this.$config.platform.apis.orders}${orderId}/items/${itemId}`,
            {
                shippingStatus: 'RETURNED',
                returnDetails,
            }
        )
        return resp
    } catch (err) {
        throw err.response.data
    }
}

const resetState = function ({ commit }) {
    commit('resetState')
}

export default {
    getOrderStatusByToken,
    orderLogin,
    getOrderTrackingDetails,
    cancelOrder,
    cancelOrderline,
    returnItem,
    resetState,
}
